import { render, staticRenderFns } from "./eventupdata.vue?vue&type=template&id=739c2322&scoped=true&"
import script from "./eventupdata.vue?vue&type=script&lang=js&"
export * from "./eventupdata.vue?vue&type=script&lang=js&"
import style0 from "./eventupdata.vue?vue&type=style&index=0&id=739c2322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739c2322",
  null
  
)

export default component.exports